import Vue from 'vue';
import _store from '@/store';

export {_store as store};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);

    isProcessing: true,

    //manual data
    courseOutline: null,
    assessments: [],
    studentScores: [],


  })
};

export const template = {
  table: {
    header: [
      // {title: 'live-class-schedule.no', id: 'no'},
      {title: 'student-enroll.student-code', id: 'studentCode', width:100},
      {title: 'student-enroll.student-name', id: 'studentName', width:230},

    ]
  },
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
